import { useEffect } from 'react';

import { useTenantStore } from '@/stores/tenantStore';

export const useRushModeEnabled = (): boolean => {
  const rushModeEnabled = useTenantStore((state) => state.remoteConfig.rushModeEnabled);
  const loadRemoteConfig = useTenantStore((state) => state.loadRemoteConfig);
  const activeTenant = useTenantStore((state) => state.activeRestaurantId);

  useEffect(() => {
    if (activeTenant) {
      const pending = loadRemoteConfig();
      void pending.catch((error) => {
        if (import.meta.env.DEV) {
          console.warn('[useRushModeEnabled] failed to load remote config', error);
        }
      });
    }
  }, [activeTenant, loadRemoteConfig]);

  return rushModeEnabled;
};
